export default __webpack_public_path__ + "static/mg-a74b8b4a827652bd437094b5cd04a3be.svg";